import { useTitle, useCookie } from 'react-use'
import useTranslate from './hooks/useTranslate'

import useCart from './hooks/useCart'
import useAbTesting from './hooks/useAbTesting'
import useAuthentication from './hooks/useAuthentication'
import useFeatureFlags from './hooks/useFeatureFlags'
import FullPageSpinner from './components/organisms/Spinner'

import Cart from './Cart'

const CartContainer = () => {
  useAbTesting()
  const t = useTranslate()
  // Redirects the customer to empty-cart when upcCartIdConsumer doesn't exist
  const [cartIdCookie] = useCookie('upcCartIdConsumer')
  if (!cartIdCookie) {
    const emptyCartError = {
      config: {
        url: '/cart-overview'
      },
      status: 404
    }
    throw emptyCartError
  }

  const { cart, isRemovingCartItems, isResettingCart } = useCart()

  const { data: featureFlags } = useFeatureFlags()
  const isAuthenticated = useAuthentication()

  useTitle(t('documentTitle'))

  if (!cart || !featureFlags) return <FullPageSpinner tip={t('spinner')} />

  return (
    <Cart
      cart={cart}
      featureFlags={featureFlags}
      isRemovingCartItems={isRemovingCartItems}
      isResettingCart={isResettingCart}
      isAuthenticated={isAuthenticated}
    />
  )
}

export default CartContainer
